
import { defineComponent, inject, ref, provide, reactive, computed } from 'vue'
import { ArrowLeft } from '@element-plus/icons-vue'
import type { FormInstance, FormRules, Action } from "element-plus";
import { useStore } from "vuex";
import { ElMessageBox } from 'element-plus'
//Components
import sFiles from "@/components/wizard/steps/sFiles.vue"
import sAcademic from '@/components/wizard/steps/StepAcademic.vue';
import sCompetition from '@/components/wizard/steps/StepCompetition.vue';
import sOficial from '@/components/wizard/steps/StepOficial.vue'
import UploadFileModal from '@/components/modals/general/UploadFileModal.vue';
import LineTime from '@/components/widgets/mixed/LineTime.vue';
import PhotoManager from '@/views/persons/photo/PhotoManager.vue';

//services
import AcrdService from '@/core/services/AcrdService';
import EventService from '@/core/services/EventService';
import FileService from "@/core/services/FileService";
import personService from "@/core/services/PersonService"
import { errManager } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
import GlobalService from '@/core/services/GlobalService';

export default defineComponent({
    components: { sFiles, sAcademic, sCompetition, sOficial, UploadFileModal, LineTime, PhotoManager },
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        action: {
            type: Number,
            required: true,
            default: 1
        },
        typeRegister: {
            type: String,
            required: true,
            default: ''
        },
        setting: {
            type: null,
            required: true,
            default: {}
        },
        listStatus: {
            type: null,
            required: false,
            default: []
        }
    },
    emits: ["onResponse"],
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const activeTab = ref('tabX');
        const REPO = ref(process.env.VUE_APP_REPO);
        const altura = screen.height;
        const loader = ref<boolean>(false)
        const loaderPhoto = ref<boolean>(false)
        const titleModal = ref('')
        const gblDialogAcrd = inject<any>('gblDialogAcrd')
        const rowAcrd = inject<any>('rowAcrd') //obtener la preinfo que será asignada a la etiqueta form
        const photo = ref<any>({})
        const paramsUpload = ref<any>({});
        const uploadPhotoRef = ref<any>(null);
        const popoverVisible = ref(false);
        const alturaSegment = ref(250);
        //const wrapperRef = ref<HTMLElement | null>(null)

        //steps
        const activeStep = ref(-1)
        const totalSteps = ref(0)
        const childComponentRef = ref<any>(null)

        //formulario de envio de observaciones
        const loading = ref(false)
        const formRec = ref<FormInstance>()
        const form = reactive(<any>{})
        const rules = reactive<FormRules>({
            checkdoc: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            },],
            message: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            },],
        });

        const options = reactive([
            {
                label: t('acrd0'),
                value: 0,
                icon: 'bi bi-person-vcard',
                disabled: false
            },
            {
                label: t('competence'),
                value: 1,
                icon: 'bi bi-image',
                disabled: false
            },
            {
                label: t('documentation'),
                value: 2,
                icon: 'bi bi-folder-fill',
                disabled: false
            },
            {
                label: t('remarks'),
                value: 3,
                icon: 'bi bi-info-circle-fill',
                disabled: false
            },

        ]);

        const optionsOT = reactive([
            {
                label: props.evento?.iscompetition == '1' ? t('competence') : t('eventData'),
                value: 0,
                icon: 'bi bi-image',
                disabled: false
            },
            {
                label: t('documentation'),
                value: 1,
                icon: 'bi bi-folder-fill',
                disabled: false
            },
            {
                label: t('remarks'),
                value: 3,
                icon: 'bi bi-info-circle-fill',
                disabled: false
            },

        ]);

        const username: any = computed < any > (() => {
            return store.getters.currentUser.account;
        });

        const listTypeFile = ref<any[]>([])
        const filesUploads = ref<any[]>([])
        const listFunctions = ref<any>([])
        provide("listTypeFile", listTypeFile)
        provide("filesUploads", filesUploads)

        const activePhotoModule = () => {
            const idperfil = store.getters.currentUser.account.idperfil;
            console.info(idperfil);
            if(idperfil == 1 || idperfil == 8){
                alturaSegment.value = 300;
                options.push({
                    label: t('photography'),
                    value: 4,
                    icon: 'bi bi-card-image',
                    disabled: false
                });

                optionsOT.push({
                    label: t('photography'),
                    value: 4,
                    icon: 'bi bi-card-image',
                    disabled: false
                });
            }
        }

        const onOpened = () => {
            activeStep.value = 0
            totalSteps.value = 1
            if (props.typeRegister == 'D') {
                totalSteps.value = 2
            }
            getListTypeFile();
            getFunctions();
            getPhoto();
            activePhotoModule();
        }

        const onClosed = () => {
            activeStep.value = -1;
            totalSteps.value = 0;
            rowAcrd.value = {};
            loaderPhoto.value = false;
            photo.value = {};
            //emit response
            emit("onResponse", { status: 'success' });
            const index = options.findIndex(item => item.value === 4);
            if (index !== -1) options.splice(index, 1);
            const index2 = optionsOT.findIndex(item => item.value === 4);
            if (index2 !== -1) optionsOT.splice(index2, 1);
        }

        const backStep = () => {
            activeStep.value--
        }

        const getPhoto = async () => {
            loaderPhoto.value = true
            personService.getPhoto({ idperson: rowAcrd.value.idperson })
                .then((res) => {
                    loaderPhoto.value = false
                    photo.value = res.data
                }).catch(({ response }) => {
                    loaderPhoto.value = false
                })
        }

        const onDialogPhoto = () => {
            if(uploadPhotoRef.value){
                paramsUpload.value.id = btoa(rowAcrd.value.idperson);
                paramsUpload.value.alias    = 'AVATAR';
                paramsUpload.value.folder   = 'fotos';
                paramsUpload.value.destiny  = 'photo'; 
                uploadPhotoRef.value.openModal();
            } 
        }

        const getListTypeFile = async () => {
            listTypeFile.value = []
            await FileService.getFiles2('acrd', 'type', { tregister: rowAcrd.value.tregister, idevent: rowAcrd.value.idevent, idsport: rowAcrd.value.idsport })
                .then((res) => {
                    listTypeFile.value = res.data
                }).catch(({ response }) => {
                    listTypeFile.value = []
                })
        }

        const getFormData = () => {
            if (activeStep.value == (totalSteps.value))
                onSaveClose()
            else {
                if (childComponentRef.value) {
                    childComponentRef.value.formRef.validate((valid: boolean) => {
                        if (valid) {
                            if ('target' in childComponentRef.value.form)
                                onUpdateCmp()
                            else
                                onSaveUpdate()
                        }
                    });
                }
            }
        };

        const onSaveUpdate = async () => {
            loader.value = true
            Object.assign(rowAcrd.value, childComponentRef.value.form)
            let target = ('idacreditation' in rowAcrd.value) ? 'update' : 'register'
            await AcrdService.options(target, rowAcrd.value)
                .then((res) => {
                    loader.value = false
                    if (res.data.status == 'success') {
                        rowAcrd.value = res.data.acrd
                        activeStep.value++;
                    } else {
                        Swal.fire({
                            icon: res.data.status,
                            title: res.data.title,
                            html: res.data.message
                        })
                    }
                    //console.log(rowAcrd.value)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onUpdateCmp = async () => {
            loader.value = true
            Object.assign(rowAcrd.value, childComponentRef.value.form)
            await AcrdService.options('change-public', rowAcrd.value)
                .then((res) => {
                    loader.value = false
                    if (res.data.status == 'success') {
                        activeStep.value++;
                    } else {
                        Swal.fire({
                            icon: res.data.status,
                            title: res.data.title,
                            html: res.data.message
                        })
                    }
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onSaveClose = () => {
            gblDialogAcrd.value = false
            emit("onResponse", { status: 'success' })
        }

        const getFunctions = async () => {
            await EventService.options('functions', { idevent: rowAcrd.value.idevent, idsport: rowAcrd.value.idsport })
                .then((res) => {
                    listFunctions.value = res.data
                }).catch(({ response }) => {
                    errManager(response)
                })
        }

        const uploadResponse = (data: any) => {
            if(data.status == 'success') getPhoto();
        }

        // Función cuando se selecciona una opción en el select
        const handleSelectChange = (value: string) => {
            console.log('Valor seleccionado:', value);
            // Mantener el popover visible después de seleccionar
            popoverVisible.value = true;
        };

        const handlePopoverVisibleChange = (visible: boolean) => {
        if (!visible) {
            popoverVisible.value = false; // El popover se cierra si no está visible
        }
        };


        const togglePopover = () => {
            popoverVisible.value = !popoverVisible.value
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid)
                    saveForm()

            });
        };

        const saveForm = async () => {
            loading.value = true
            form.idacrd = rowAcrd.value.idacreditation
            await GlobalService.post('acreditation/change-status', form)
                .then((res) => {
                    loading.value = false
                    if (res.data.status) {
                        rowAcrd.value.checkdoc = res.data?.check?.checkdoc
                        rowAcrd.value.checkstatus = res.data?.check?.checkstatus
                        rowAcrd.value.checkClass = res.data?.check?.checkClass
                        ElMessageBox.alert(res.data.message, process.env.VUE_APP_NAME, {
                            confirmButtonText: 'OK',
                            callback: (action: Action) => {
                                resetForm(formRec.value)
                            },
                        })
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const aproved = async () => {
            loading.value = true
            await GlobalService.post('acreditation/change-status', {
                idacrd: rowAcrd.value.idacreditation,
                checkdoc: 1,
                message: "Aprobado"
            })
                .then((res) => {
                    loading.value = false
                    if (res.data.status) {
                        rowAcrd.value.checkdoc = 1
                        rowAcrd.value.checkstatus = res.data?.check?.checkstatus
                        rowAcrd.value.checkClass = res.data?.check?.checkClass
                        ElMessageBox.alert(res.data.message, process.env.VUE_APP_NAME, {
                            confirmButtonText: 'OK',
                            callback: (action: Action) => {
                                //dialogAcreditation.value = false
                            },
                        })
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }
        

        /*
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node
            if (
                popoverVisible.value &&
                wrapperRef.value &&
                !wrapperRef.value.contains(target)
            ) {
                popoverVisible.value = false
            }
        }
        */

        /*
        onMounted(() => {
            document.addEventListener('click', handleClickOutside)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('click', handleClickOutside)
        })

        const handleSelectChange = (value: any) => {
            console.log('Opción seleccionada:', value)
            // El popover no se cerrará automáticamente
        }
        */

        return {
            t,
            REPO,
            altura,
            loader,
            activeTab,
            options,
            optionsOT,
            loaderPhoto,
            photo,
            titleModal,
            rowAcrd,
            gblDialogAcrd,
            activeStep,
            totalSteps,
            paramsUpload,
            uploadPhotoRef,
            formRec,
            form,
            rules,
            alturaSegment,
            //icons
            ArrowLeft,
            listTypeFile,
            listFunctions,
            //wrapperRef,
            popoverVisible,
            username,
            loading,
            //events
            onOpened,
            onClosed,
            getListTypeFile,
            backStep,
            getFunctions,
            childComponentRef,
            getFormData,
            onDialogPhoto,
            uploadResponse,
            togglePopover,
            handleSelectChange,
            handlePopoverVisibleChange,
            resetForm,
            submitForm,
            aproved,
        }
    },
})
